import VehicleIcon from '../components/Icons/VehicleIcon';
import MotorcycleIcon from '../components/Icons/Vehicles/MotorcycleIcon';
import CarIcon from '../components/Icons/Vehicles/CarIcon';
import ATVIcon from '../components/Icons/Vehicles/AtvIcon';
import BuggyIcon from '../components/Icons/Vehicles/BuggyIcon';
import GoKartIcon from '../components/Icons/Vehicles/GoKartIcon';
import { VEHICLE_TYPES } from '../constants/vehicleTypes';

// Mapeo de tipos de vehículos a sus iconos correspondientes
export const VEHICLE_ICON_MAP = {
  [VEHICLE_TYPES.MOTORCYCLE]: MotorcycleIcon,
  [VEHICLE_TYPES.CAR]: CarIcon,
  [VEHICLE_TYPES.ATV]: ATVIcon,
  [VEHICLE_TYPES.BUGGY]: BuggyIcon,
  [VEHICLE_TYPES.GO_KART]: GoKartIcon,
};

/**
 * Obtiene el componente de icono correspondiente al tipo de vehículo
 * @param {string} vehicleType - Tipo de vehículo
 * @returns {React.Component} Componente de icono
 */
export const getVehicleIcon = (vehicleType) => {
  return VEHICLE_ICON_MAP[vehicleType] || VehicleIcon;
};

/**
 * Obtiene las props por defecto para los iconos de vehículos
 * @param {string} color - Color del icono (opcional)
 * @returns {object} Props por defecto
 */
export const getDefaultIconProps = (color = '#6B7280') => ({
  fill: color,
  width: 28,
  height: 24,
});
